import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsShellComponent } from './simple-icons-shell.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsShellComponent ],
    exports:      [ SimpleIconsShellComponent ],
    bootstrap:    []
})
export class SimpleIconsShellModule {}
